import SecondaryControlButton from './SecondaryControlButton';

export default SecondaryControlButton;
